"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconCloseCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 5.17157L7.41421 4.58579C6.63316 3.80474 5.36683 3.80474 4.58579 4.58579C3.80474 5.36683 3.80474 6.63317 4.58579 7.41421L5.17157 8L4.58579 8.58579C3.80474 9.36684 3.80474 10.6332 4.58579 11.4142C5.36683 12.1953 6.63317 12.1953 7.41421 11.4142L8 10.8284L8.58579 11.4142C9.36683 12.1953 10.6332 12.1953 11.4142 11.4142C12.1953 10.6332 12.1953 9.36684 11.4142 8.58579L10.8284 8L11.4142 7.41421C12.1953 6.63317 12.1953 5.36684 11.4142 4.58579C10.6332 3.80474 9.36684 3.80474 8.58579 4.58579L8 5.17157Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L10 11.4142L7.70711 13.7071C7.31659 14.0976 6.68342 14.0976 6.2929 13.7071C5.90237 13.3166 5.90237 12.6834 6.2929 12.2929L8.58579 10L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L10 8.58579L12.2929 6.29289C12.6834 5.90237 13.3166 5.90237 13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711L11.4142 10L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 9.17157L9.41421 6.58579C8.63317 5.80474 7.36684 5.80474 6.58579 6.58579C5.80474 7.36683 5.80474 8.63317 6.58579 9.41421L9.17157 12L6.58579 14.5858C5.80474 15.3668 5.80474 16.6332 6.58579 17.4142C7.36684 18.1953 8.63317 18.1953 9.41421 17.4142L12 14.8284L14.5858 17.4142C15.3668 18.1953 16.6332 18.1953 17.4142 17.4142C18.1953 16.6332 18.1953 15.3668 17.4142 14.5858L14.8284 12L17.4142 9.41421C18.1953 8.63317 18.1953 7.36684 17.4142 6.58579C16.6332 5.80474 15.3668 5.80474 14.5858 6.58579L12 9.17157Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg',
    stroke: 'currentColor',
    'stroke-width': '2'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L16 18.1213L10.5607 23.5607C9.97488 24.1464 9.02513 24.1464 8.43934 23.5607C7.85355 22.9749 7.85355 22.0251 8.43934 21.4393L13.8787 16L8.43934 10.5607C7.85355 9.97487 7.85355 9.02513 8.43934 8.43934C9.02513 7.85355 9.97487 7.85355 10.5607 8.43934L16 13.8787L21.4393 8.43934C22.0251 7.85355 22.9749 7.85355 23.5607 8.43934C24.1464 9.02513 24.1464 9.97487 23.5607 10.5607L18.1213 16L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;